<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div>
  @if (label) {
    <label [attr.for]="id" class="select-label" [xdaTranslate]="label"></label>
  }
  @if (label) {
    <br />
  }
  <div
    ngbDropdown
    class="bootstrap-select dropdown dropdown-block"
    [id]="id"
    [ngClass]="{ 'is-invalid': isErrorState() }"
    [ngStyle]="{ 'min-width': dropdownMinWidth }">
    <button
      type="button"
      class="xrx-btn dropdown-toggle btn-secondary"
      [ngClass]="{ btn: isMfd, medium: isMfd }"
      [id]="id"
      ngbDropdownToggle>
      @if (selectedItem && (selectedItem.glyph || selectedItem.icon?.image)) {
        <span class="filter-option">
          @if (selectedItem.glyph) {
            <i [ngClass]="selectedItem.glyph"></i>
          }
          @if (selectedItem.icon?.image) {
            <img [src]="selectedItem.icon.image" />
          }
          <span
            class="filter-option-label"
            [xdaTranslate]="selectedItem[localize]"></span>
        </span>
      }
      @if (!selectedItem) {
        <span class="filter-option" [xdaTranslate]="inlineLabel"></span>
      }
      @if (selectedItem && !selectedItem.glyph && !selectedItem.icon?.image) {
        <span
          class="filter-option"
          [xdaTranslate]="selectedItem[localize]"></span>
      }
      <span class="select-btn-caret"
        ><i class="caret xgl-navigate_down" [ngClass]="{ mfd: isMfd }"></i
      ></span>
    </button>
    @if (isErrorState()) {
      <div class="invalid-feedback">
        @if (required) {
          <div [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></div>
        }
        @if (error) {
          <div [xdaTranslate]="error"></div>
        }
      </div>
    }
    @if (type != 'group') {
      <div
        [attr.aria-labelledby]="id"
        class="dropdown-menu select-dropdown"
        ngbDropdownMenu>
        @for (item of list; track item) {
          <div
            (click)="selectItem(item)"
            [ngClass]="{
              selected:
                selectedItem &&
                getPropertyString('property', item) ===
                  getPropertyString('property'),
            }"
            ngbDropdownItem>
            @if (item.glyph) {
              <span [ngClass]="item.glyph"></span>
            }
            @if (typeof item.icon !== 'string' && item.icon?.image) {
              <img [src]="item.icon?.image" />
            }
            <span [xdaTranslate]="getPropertyString('localize', item)"></span>
          </div>
        }
      </div>
    }
    @if (type == 'group') {
      <div
        [attr.aria-labelledby]="id"
        class="dropdown-menu select-dropdown"
        ngbDropdownMenu>
        @for (group of list; track group; let isLast = $last) {
          <div>
            @if (group.title) {
              <span class="dropdown-header" [xdaTranslate]="group.title"></span>
            }
            @for (item of group.options; track item) {
              <div
                (click)="selectItem(item)"
                [ngClass]="{
                  selected:
                    selectedItem &&
                    getPropertyString('property', item) ===
                      getPropertyString('property'),
                }"
                ngbDropdownItem>
                <span
                  [xdaTranslate]="getPropertyString('localize', item)"
                  [ngClass]="{ opt: group.title }"></span>
              </div>
            }
            @if (!isLast) {
              <div class="dropdown-divider"></div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
